'use client';

import { UIMarket } from '@velocity-exchange/common';
import MarketIcon from 'src/components/Utils/MarketIcon';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BalanceRowData } from './types';
import { PRESETS } from 'src/utils/formatNumber/presets';

interface EarningsCellProps {
	row: BalanceRowData;
}

export function EarningsCell({ row }: EarningsCellProps) {
	const { spotMarketIndex, base90DayEarning, quote90DayEarning } = row;
	const uiMarket = UIMarket.createSpotMarket(spotMarketIndex);

	return (
		<div className="flex flex-col gap-y-xs">
			<div className="flex items-center gap-x-xs">
				<MarketIcon
					marketSymbol={uiMarket.uiSymbols.marketDisplaySymbol}
					className="size-lg"
				/>
				<NumberDisplay
					value={base90DayEarning}
					options={PRESETS.tradePrecisionTrim}
					className="typo-label-xs text-text-default"
					loading={base90DayEarning === undefined}
					skeletonClassName="h-3 w-10"
					isAccountValueToHide
				/>
			</div>
			<NumberDisplay
				value={quote90DayEarning}
				options={PRESETS.usd}
				className="typo-body-xs text-text-secondary"
				loading={quote90DayEarning === undefined}
				skeletonClassName="h-4 w-12"
				isAccountValueToHide
			/>
		</div>
	);
}
